module.exports = __webpack_public_path__ + "static/media/shapes-secondary2.ca90a493.svg";